export const MOCK_CONCENTRATION_DATA = {
    clients: [
        { name: 'Bogan Group LLC', balance: '658989.21', concentration: '0.223385' },
        { name: 'Veum-Mertz LLC', balance: '629073.97', concentration: '0.213245' },
        { name: 'Okuneva-Nolan LLC', balance: '476294.59', concentration: '0.161455' },
        { name: 'Alexis Bank Co', balance: '455000.0', concentration: '0.154236' },
        { name: 'Pinnacle Minds', balance: '446566.1', concentration: '0.151378' },
        { name: 'Streich LLC LLC', balance: '219695.09', concentration: '0.074473' },
        { name: 'Nolan-Bednar LLC', balance: '94396.87', concentration: '0.032000' },
    ],
    debtors: [
        {
            name: 'Abshire, Conn and Kovacek',
            balance: '1403401.0',
            concentration: '0.223150343318403042576598817048022153',
        },
        {
            name: 'Youth Connection Charter School',
            balance: '849606.73',
            concentration: '0.135093272332801357434941898626293094',
        },
        { name: 'Lehner LLC', balance: '685072.0', concentration: '0.108931126597333911821379423837322784' },
        { name: 'Choice HomeCare, Inc.', balance: '559779.32', concentration: '0.089008734809610509511864060036971791' },
        { name: 'Hansen-Hahn', balance: '507777.0', concentration: '0.080740010787500323678276998180985723' },
        { name: 'Nader Group', balance: '494508.0', concentration: '0.07863014916883830906381620635925394' },
        { name: 'Thompson Group', balance: '462379.0', concentration: '0.073521418748611323793787509363216526' },
        {
            name: 'Collins, Reilly and Prohaska',
            balance: '456499.0',
            concentration: '0.07258645859202585043987768526857617',
        },
        { name: 'Weissnat LLC', balance: '445565.0', concentration: '0.070847877919899053560345369511637793' },
        {
            name: 'Okuneva, Auer and Ondricka',
            balance: '424451.0',
            concentration: '0.067490607724976318119112031767720025',
        },
    ],
};
export const MOCK_PORTFOLIO_DATA = {
    totals: {
        net_funds_employed: 10_984_658.29,
        outstanding_funded_invoices: 500000,
        total_ineligible_invoices: 1_902_588,
        total_outstanding_invoices: 9_739_104.39,
        mtd_earned_fees: 35_863.25,
        funds_due: 3_564_075.17,
        mtd_chargebacks: 2_075,
        funds_employed: 800000,
    },
};
export const MOCK_FEES_AR_DATA = [
    { balance_year: 2024, balance_month: 4, outstanding_ar: '3254902.0', fees: '8653.72', month_return: '0.00265867298' },
    {
        balance_year: 2024,
        balance_month: 5,
        outstanding_ar: '4670284.0',
        fees: '37541.384',
        month_return: '0.008038351415',
    },
    {
        balance_year: 2024,
        balance_month: 6,
        outstanding_ar: '12783586.65',
        fees: '32085.79',
        month_return: '0.002509920798',
    },
    {
        balance_year: 2024,
        balance_month: 7,
        outstanding_ar: '5954648.0',
        fees: '19418.8375',
        month_return: '0.003261122656',
    },
    {
        balance_year: 2024,
        balance_month: 8,
        outstanding_ar: '5843774.0',
        fees: '21287.9',
        month_return: '0.003642834237',
    },
    {
        balance_year: 2024,
        balance_month: 9,
        outstanding_ar: '7395774.39',
        fees: '6844.65',
        month_return: '0.000925481179',
    },
    { balance_year: 2024, balance_month: 10, outstanding_ar: '1100542.0', fees: '25.0', month_return: '0.00002271608' },
    { balance_year: 2024, balance_month: 11, outstanding_ar: '2715501.0', fees: '21.8', month_return: '0.000008027985' },
    { balance_year: 2024, balance_month: 12, outstanding_ar: '1150452.0', fees: '25.0', month_return: '0.000021730589' },
    {
        balance_year: 2025,
        balance_month: 1,
        outstanding_ar: '1117952.0',
        fees: '16166.27',
        month_return: '0.014460611905',
    },
];
export const MOCK_AR_AGING_DATA = {
    ar_data: [
        {
            '1-30': 257864.92,
            '31-60': 128390.11,
            '61-90': 65312.89,
            '91-120': 10328.55,
            '121+': 14398.12,
            total: 476294.59,
            business_id: 7022,
            business_name: 'Okuneva-Nolan LLC',
        },
        {
            '1-30': 12583.15,
            '31-60': 25638.54,
            '61-90': 56175.18,
            '91-120': 0,
            '121+': 0,
            total: 94396.87,
            business_id: 7025,
            business_name: 'Nolan-Bednar LLC',
        },
        {
            '1-30': 76274.65,
            '31-60': 250785.0,
            '61-90': 103259.02,
            '91-120': 14592.87,
            '121+': 1654.56,
            total: 446566.1,
            business_id: 7053,
            business_name: 'Pinnacle Minds',
        },
        {
            '1-30': 102837.56,
            '31-60': 85236.1,
            '61-90': 12500.0,
            '91-120': 19121.43,
            '121+': 0,
            total: 219695.09,
            business_id: 7023,
            business_name: 'Streich LLC',
        },
        {
            '1-30': 368750.0,
            '31-60': 179085.5,
            '61-90': 98653.71,
            '91-120': 12500.0,
            '121+': 0,
            total: 658989.21,
            business_id: 7026,
            business_name: 'Bogan Group LLC',
        },
        {
            '1-30': 550232.12,
            '31-60': 65300.92,
            '61-90': 12282.5,
            '91-120': 0,
            '121+': 1258.43,
            total: 629073.97,
            business_id: 7024,
            business_name: 'Veum-Mertz LLC',
        },
        {
            '1-30': 150000.0,
            '31-60': 100000.0,
            '61-90': 50000.0,
            '91-120': 125000.0,
            '121+': 30000.0,
            total: 455000.0,
            business_id: 7038,
            business_name: 'Alexis Bank Co',
        },
    ],
    totals: {
        '1-30': 1518542.4,
        '31-60': 834436.17,
        '61-90': 398183.3,
        '91-120': 181542.85,
        '121+': 17311.11,
        total: 2950015.83,
    },
    count: 7,
};
